/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Preferedsecondsubject2Inputs */

const de__field_preferedsecondsubject2 = /** @type {(inputs: _Field_Preferedsecondsubject2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevorzugtes Zweitfach`)
};

/**

* @param {_Field_Preferedsecondsubject2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_preferedsecondsubject2 = /** @type {((inputs?: _Field_Preferedsecondsubject2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Preferedsecondsubject2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_preferedsecondsubject2(inputs)
});
export { _field_preferedsecondsubject2 as "_field_preferedSecondSubject" }